import React from 'react'
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'

import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import { cn } from '@/lib/utils'

type CalendarComponents = NonNullable<
  React.ComponentProps<typeof Calendar>['components']
>

export const CalendarRoot: NonNullable<CalendarComponents['Root']> =
  function CalendarRoot({ className, rootRef, ...props }) {
    return (
      <div
        ref={rootRef}
        className={cn('mx-0 w-full', className, 'w-full')}
        {...props}
      />
    )
  }

export const CalendarMonth: NonNullable<CalendarComponents['Month']> =
  function CalendarMonth({ children }) {
    return <div className="w-full">{children}</div>
  }

export const CalendarMonthGrid: NonNullable<CalendarComponents['MonthGrid']> =
  function CalendarMonthGrid({ children, ...props }) {
    return (
      <div {...props} className="">
        {children}
      </div>
    )
  }

export const CalendarNextMonthButton: NonNullable<
  CalendarComponents['NextMonthButton']
> = function CalendarNextMonthButton({ children: _children, ...props }) {
  if (props['aria-disabled']) {
    return <div className="size-10" aria-hidden="true" />
  }

  return (
    <Button
      variant="ghost"
      size="icon-lg"
      {...props}
      className="pop-in rounded-full"
    >
      <LuChevronRight />
    </Button>
  )
}

export const CalendarPreviousMonthButton: NonNullable<
  CalendarComponents['PreviousMonthButton']
> = function CalendarPreviousMonthButton({ children: _children, ...props }) {
  if (props['aria-disabled']) {
    return <div className="size-10" aria-hidden="true" />
  }

  return (
    <Button
      variant="ghost"
      size="icon-lg"
      {...props}
      className="pop-in rounded-full"
    >
      <LuChevronLeft />
    </Button>
  )
}

export const CalendarWeeks: NonNullable<CalendarComponents['Weeks']> =
  function CalendarWeeks({ children, ...props }) {
    return (
      <div {...props} className="grid w-full grid-cols-7 gap-1">
        {children}
      </div>
    )
  }

export const CalendarWeekdays: NonNullable<CalendarComponents['Weekdays']> =
  function CalendarWeekdays({ children, ...props }) {
    return (
      <div {...props} className="gap mt-3 grid w-full grid-cols-7 gap-1">
        {children}
      </div>
    )
  }

export const CalendarWeekday: NonNullable<CalendarComponents['Weekday']> =
  function CalendarWeekday({ children, ...props }) {
    return (
      <div
        {...props}
        className="mb-3 grid h-full w-full place-items-center text-center
          font-bold"
      >
        {children}
      </div>
    )
  }

export const CalendarWeek: NonNullable<CalendarComponents['Week']> =
  function CalendarWeek({ children }) {
    return <>{children}</>
  }
